<template>
    <div>
        <v-card>
            <div>
                <v-toolbar flat color="white">
                    <v-toolbar-title>{{ header }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn depressed color="primary" @click="submitVideo" :disabled="!(thumbUrl) || errors.any()" :loading="submitting">Publish</v-btn>
                </v-toolbar>
                <v-divider></v-divider>
            </div>
            <div>
                <v-container fluid>
                    <v-layout row>
                        <v-flex xs12 md6>
                            <v-text-field
                                    label="Title"
                                    light
                                    name="title"
                                    :autofocus="true"
                                    v-model="model.title"
                                    placeholder="Please enter video title"
                                    v-validate="'required'"
                                    :success="!errors.first('title')"
                                    :error-messages="errors.first('title')"
                            ></v-text-field>
                            <v-textarea
                                    label="Description"
                                    name="description"
                                    v-model="model.description"
                                    @keyup="contentChanged"
                                    placeholder="Please enter video description"
                                    v-validate="'required'"
                                    :success="!errors.first('description')"
                                    :error-messages="errors.first('description')"
                            ></v-textarea>
                            <div>
                                <h3 v-html="translatedText"></h3>
                            </div>
                            <v-select
                                    :items="filters"
                                    name="category"
                                    label="Playlist"
                                    v-model="model.category"
                                    placeholder="Please select video playlist"
                                    :rules="categoryRule"
                                    :success="model.category"
                            ></v-select>
                            <v-combobox
                                    :items="filters_tags"
                                    name="tags"
                                    label="Tags"
                                    v-model="model.tags"
                                    placeholder="Please add video tags"
                                    multiple
                                    persistent-hint
                                    small-chips
                                    v-validate="'required'"
                                    :success="!errors.first('tags')"
                                    :error-messages="errors.first('tags')"
                            >
                                <template slot="no-data">
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-list-tile-title>
                                                No results matching "
                                                <strong>{{ search }}</strong>". Press
                                                <kbd>enter</kbd> to create a new one
                                            </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-combobox>

                            <v-checkbox
                                    v-model="model.downloadable"
                                    label="Enable download"
                                    color="primary"
                            ></v-checkbox>

                        </v-flex>
                        <v-flex xs12 md6 pl-4>
                            <h4 class="grey--text lighten-1 mb-2" v-if="thumbUrl ==''">Upload your video</h4>

                            <div>
                                <v-btn class="fileContainer" v-if="thumbUrl ==''">
                                    <input
                                            type="file"
                                            id="file"
                                            ref="file"
                                            style="opacity: 0; width: 0; height: 0;"
                                            accept="video/*"
                                            v-on:change="handleFileUpload()"
                                    >
                                    Select video file
                                </v-btn>

                                <v-btn class="fileContainer" v-if="this.videoId !== undefined">
                                    <input
                                            type="file"
                                            id="subtitleFile"
                                            ref="subtitleFile"
                                            style="opacity: 0; width: 0; height: 0;"
                                            accept=".srt"
                                            v-on:change="handleSubtitleFileUpload()"
                                    >
                                    Select Subtitle File
                                </v-btn>

                                <v-progress-linear
                                        v-model="progress"
                                        v-if="progress"
                                        :indeterminate="indeterminate"
                                ></v-progress-linear>
                                <p v-if="progress">{{ displayLoadedSize }}/{{ displayTotalSize }}</p>

                                <!-- <video :src="uploadFileUrl" v-if="uploadFileUrl" height="240" controls></video> -->
                                <v-alert :value="true" type="success" v-if="thumbUrl" outline class="processing">
                                    <b>Status: Uploaded and Processing...</b>
                                    <br>The video has been uploaded. You can publish video now. It will be available as soon as processed.
                                    <br>Processing video might take 10-25 minutes depending on the size of video.
                                </v-alert>

                                <v-alert :value="true" type="error" v-if="uploadError" outline class="processing">
                                    <b>Status: Failed!</b>
                                    <br>The video file you have uploaded is in invalid format. Please select upload another file.
                                </v-alert>

                                <v-btn
                                        depressed
                                        v-if="thumbUrl"
                                        color="red"
                                        v-on:click="reset()"
                                        class="ml-0 white--text"
                                        flat
                                >Remove video
                                </v-btn>

                                <div class="mt-2">
                                    <h4 class="grey--text lighten-1 mb-2">Video thumbnail</h4>
                                    <p v-if="!thumbUrl">Please upload video first.</p>
                                    <img :src="thumbUrl" v-if="thumbUrl" width="200">
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </v-card>
    </div>
</template>

<script>
  import Vue from "vue";
  import Axios from "axios";

  export default {
    data() {
      return {
        categoryurl: "/videos/categoryitem",
        url: "/api/videos/upload",
        removeUrl: "/api/videos/remove",
        submitUrl: "/api/videos",
        translatedText: '',
        progress: 0,
        displayLoadedSize: 0,
        displayTotalSize: 0,
        indeterminate: false,
        file: "",
        search: "",
        fileSize: 2147483648,
        uploadFileUrl: "",
        thumbUrl: "",
        model: {
          title: "",
          description: "",
          category: "",
          downloadable: true,
          tags: [],
          video: {},
          subtitlePath: '',
        },
        header: "Upload Video",
        items: [],
        categoryRule: [ v => !!v || 'Playlist is required' ],
        uploadError: false,
        submitting: false,
        filters: this.categoryitems(),
        filters_tags : this.tagitems(),
      };
    },
    methods: {
      handleFileUpload() { 
        this.uploadError = false;
        this.file = this.$refs.file.files[0];
        this.startUpload();
      },
      handleSubtitleFileUpload() {
        this.subtitleUploadError = false;
        this.subtitleFile = this.$refs.subtitleFile.files[0];
        this.startSubtitleUpload();    
      },
      categoryitems(){
        Axios.get('/videos/categoryitem').then( response => {
          this.filters=Object.values(response.data);
        } ).catch((error) => {
          this.success = false;
        });
      },
      tagitems(){
        Axios.get('/videos/tagitem').then( response => {
          this.filters_tags = Object.values(response.data);
        } ).catch((error) => {
          this.success = false;
        });
      },
      startUpload() {
        let formData = new FormData();
        formData.append("file", this.file);

        const config = {
          onUploadProgress: this.onProgress,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        Axios.post(this.url, formData, config)
          .then(response => {
            this.progress = 0;
            this.thumbUrl = response.data["thumbnail"];
            this.videoId = response.data["videoId"];
            this.model.video = response.data;
          })
          .catch(error => {
            console.log(error.response);
            this.uploadError = true;
          });
      },
      startSubtitleUpload() {
        let formData = new FormData();
        formData.append("subtitleFile", this.subtitleFile);
        formData.append("videoId", this.videoId);

        const config = {
          onUploadProgress: this.onProgress,
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };

        Axios.post('/api/videos/uploadSubtitle', formData, config)
          .then(response => {
            this.model.subtitlePath = response.data.subtitlePath;
            
          })
          .catch(error => {
            console.log(error.response);
            this.subtitleUploadError = true;
          });
      },
      onProgress(event) {
        if (event.lengthComputable || this.file.size) {
          let size = this.file.size || event.total;
          this.progress = parseInt((event.loaded * 100) / size);
          this.displayLoadedSize = this.humanFileSize(event.loaded);
          this.displayTotalSize = this.humanFileSize(size);
        } else {
          this.indeterminate = true;
        }
      },
      async reset() {
        this.progress = 0;
        this.thumbUrl = "";
        this.file = null;
        try {
          Axios.post(this.removeUrl, {video: this.model.video});
          this.model.video = null;
        } catch (err) {
          this.thumbUrl = this.model.video["thumbnail"];
        }
      },
      humanFileSize(bytes) {
        let thresh = 1000;
        if (Math.abs(bytes) < thresh) {
          return bytes + " B";
        }
        let units = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        let u = -1;
        do {
          bytes /= thresh;
          ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + " " + units[u];
      },
      async contentChanged($evt) {
//        if($evt.code !== "Space") {
//          return;
//        }
//        let sourceText = this.model.description;
//        let sourceLang = 'en';
//        let targetLang = 'pa';
//        let url = "https://translate.googleapis.com/translate_a/single?client=gtx&sl="
//          + sourceLang + "&tl=" + targetLang + "&dt=t&q=" + encodeURI(sourceText);
//
//        const result = await fetch(url);
//        const json = await result.json();
//
//        this.translatedText = json[0][0][0];
      },
      async submitVideo(){
        await this.$validator.validateAll();
        if(this.errors.any()){
          return;
        }
        try{
          this.submitting = true;
          await Axios.post(this.submitUrl, this.model);
          this.submitting = false;
          this.$router.push('/videos');
        }catch (e){
          this.submitting= false
        }
      }
    },
    mounted() {
      window.onbeforeunload = () => {
        return "Hey, are you want sure want to unload the page? This may cause a loss of unsaved information.";
      };
      window.unload = () => {
        if(this.model.video){
          this.reset();
        }
      }
    }
  };
</script>

<style>
    .dropzone-custom-content {
        text-align: center;
    }

    .dropzone-custom-title {
        margin-top: 0;
        color: #1078d5;
    }

    .subtitle {
        color: #314b5f;
    }

    .fileContainer {
        margin: 0 0 10px 0;
    }

    .fileContainer [type="file"] {
        cursor: inherit;
        display: block;
        filter: alpha(opacity=0);
        min-height: 100%;
        min-width: 100%;
        opacity: 0;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
    }

    .font-select {
        width: 150px
    }

    .ve-select span {
        font-size: 14px;
    }

    .ve-select {
        min-width: 75px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/videos/create.vue